<template>
  <div
    :class="{ 'form-popup-overlay': true, 'is-visible': isVisible, 'px-5': true }"
    @click="hide">
    <div
      :class="{ 'form-popup': true, 'px-5': true, 'pb-4': true, 'pt-4': true, 'is-loading': loading }"
      @click.stop>
      <h3 class="text-center">
        Add reward
      </h3>

      <validation-observer ref="reward-form" tag="form">
        <d-row>
          <div class="form-group w-100">
            <validation-provider
              rules="required"
              name="name"
              v-slot="{ errors }">
              <label for="name">Name:</label>
              <d-input
                v-model="data.name"
                :state="errors.length ? 'invalid' : null" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </d-row>

        <d-row>
          <div class="form-group w-100">
            <validation-provider
              rules="required"
              name="reference"
              v-slot="{ errors }">
              <label for="reference">Reference:</label>
              <d-input
                v-model="data.reference"
                :state="errors.length ? 'invalid' : null" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </d-row>
      </validation-observer>

      <d-row>
        <div class="text-center w-100">
          <d-button
            @click.prevent="validateForm"
            theme="success"
            class="mr-5">
            Save
          </d-button>

          <d-button
            @click.prevent="cancel"
            outline
            theme="secondary">
            Cancel
          </d-button>
        </div>
      </d-row>
    </div>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils';

export default {
  name: 'RewardPopup',
  data () {
    return {
      isVisible: false,
      loading: false,
      data: {
        name: '',
        reference: '',
        reference_id: null,
        reference_type: null
      }
    };
  },
  mounted () {
    this.$bus.$on('show-reward-popup', this.show);
  },
  methods: {
    show (referenceType = false, referenceId = false) {
      this.data = {
        name: '',
        reference: '',
        reference_id: referenceId,
        reference_type: referenceType
      };

      setTimeout(() => {
        this.$refs['reward-form'].reset();
        this.isVisible = true;
      }, 100);
    },
    validateForm () {
      FormUtils.validate(this.$refs['reward-form'], this.submitForm);
    },
    submitForm () {
      this.loading = true;
      let formDataToSend = this.prepareFormData();

      FormUtils.submit({
        $http: this.$http,
        endpoint: '/rewards/store',
        formData: formDataToSend,
        successTitle: 'Reward added',
        successText: '',
        errorTitle: 'An error occurred',
        errorText: 'The system was unable to save the reward. Please try again.',
        successAction: () => {
          this.loading = false;
          this.isVisible = false;
          this.$bus.$emit('rewards-list-reload');
        }
      });
    },
    cancel () {
      this.isVisible = false;
      this.loading = false;
    },
    hide () {
      this.isVisible = false;
      this.loading = false;
    },
    prepareFormData () {
      let dataToSend = {
        name: this.data.name,
        reference: this.data.reference,
        reference_type: this.data.reference_type,
        reference_id: this.data.reference_id
      };

      return dataToSend;
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-reward-popup', this.show);
  }
}
</script>
